import(/* webpackMode: "eager", webpackExports: ["AppHomePageSkeleton"] */ "/home/danielwong/facility-calcom/cal2/apps/web/app/(use-page-wrapper)/apps/(homepage)/skeleton.tsx");
